export default function(target, type, selection) {
  this.target = target;
  this.type = type;
  this.selection = selection;
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-brush/src/event.js
// module id = e4Fn
// module chunks = 0